import React from 'react';
import CallCenterServices from '../components/services/CallCenterServices';
import DebtRecovery from '../components/services/DebtRecovery';
import './ServicesPage.css';

const ServicesPage = () => {
    return ( <
        div className = "services-page" >
        <
        CallCenterServices / >
        <
        DebtRecovery / >
        <
        /div>
    );
};

export default ServicesPage;